export const Role = {
    ADMIN: "1ff3df5f-f470-4120-ad42-c47dfcaeb627",
    USER: "6a223d8b-4335-4ab8-af88-6413866638b1",
    GUEST: "d350d376-63bb-47f0-a075-6a0a679718d0",
};
